import { render, staticRenderFns } from "./indica-list-from-url.vue?vue&type=template&id=0ef07e84&scoped=true&"
import script from "./indica-list-from-url.vue?vue&type=script&lang=js&"
export * from "./indica-list-from-url.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef07e84",
  null
  
)

export default component.exports